import Paginate from "./../../utils/Paginate";
import { FormatMoney } from "./../../utils/formatMoney";
import {
  convert,
  DisplayCurrentTime,
  formatDate,
} from "./../../utils/convertDate";
import { useState } from "react";

export const TransferTable = ({
  pageIndex,
  pageNumber,
  transfers,
  nextPage,
  setPageIndex,
  prevPage,
  totalPage,
}) => {
  const statusStyles = {
    Success: "bg-green-500 text-white",
    Pending: "bg-amber-400 text-white",
    Failed: "bg-orange-600 text-white",
  };

  function classNames(...classes) {
    return classes.filter(Boolean).join(" ");
  }

  return (
    <>
      <div className="mt-8 flex flex-col">
        <div className="-my-2 -mx-4 overflow-x-auto sm:-mx-6 lg:-mx-8">
          <div className="inline-block min-w-full py-2 align-middle md:px-6 lg:px-8">
            <div className="relative overflow-hidden ring-1 ring-black ring-opacity-5 md:rounded-lg">
              <table className="min-w-full table-fixed divide-y divide-gray-300">
                <thead>
                  <tr>
                    <th
                      scope="col"
                      className="pl-3 min-w-[6rem] py-3.5 pr-3 italic font-normal text-left text-sm  text-gray-400"
                    >
                      Reference Number
                    </th>
                    <th
                      scope="col"
                      className="px-3 py-3.5 text-left text-sm italic font-normal text-gray-400 "
                    >
                      Sender's Account Name
                    </th>
                    <th
                      scope="col"
                      className=" min-w-[10rem] px-3 py-3.5 text-left text-sm italic font-normal text-gray-400 "
                    >
                      Sender's Account Number
                    </th>
                    <th
                      scope="col"
                      className="px-3 py-3.5 text-left text-sm italic font-normal text-gray-400"
                    >
                      Amount
                    </th>
                    <th
                      scope="col"
                      className="px-3 py-3.5 text-left text-sm italic font-normal text-gray-400"
                    >
                      Receiver's Name
                    </th>
                    <th
                      scope="col"
                      className="px-3 py-3.5 text-left text-sm italic font-normal text-gray-400"
                    >
                      Transfer Date
                    </th>
                    <th
                      scope="col"
                      className="px-3 py-3.5 text-left text-sm italic font-normal text-gray-400"
                    >
                      Transfer Time
                    </th>
                    <th
                      scope="col"
                      className="px-3 py-3.5 min-w-[8rem] text-left text-sm italic font-normal text-gray-400"
                    >
                      Receiver's Account Number
                    </th>
                    <th
                      scope="col"
                      className="px-3 py-3.5 text-left text-sm italic font-normal text-gray-400"
                    >
                      Bank Name
                    </th>
                    <th
                      scope="col"
                      className="px-3 py-3.5 text-left text-sm italic font-normal text-gray-400"
                    >
                      Account Status
                    </th>
                    <th
                      scope="col"
                      className="px-3 py-3.5 text-left text-sm italic font-normal text-gray-400"
                    >
                      Transfer Type
                    </th>
                    <th
                      scope="col"
                      className="px-3 min-w-[12rem] py-3.5 text-left text-sm italic font-normal text-gray-400"
                    >
                      Error Message
                    </th>

                    <th
                      scope="col"
                      className="px-3 py-3.5 text-left text-sm italic font-normal text-gray-400"
                    >
                      <span className="sr-only">Edit</span>
                    </th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-200 bg-white">
                  {transfers.map((person, i) => (
                    <tr key={i} className="bg-gray-50">
                      <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">
                        {person.transactionReference}
                      </td>
                      <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">
                        {person.sourceAccountName}
                      </td>
                      <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">
                        {person.sourceAccountNumber}
                      </td>
                      <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">
                        {FormatMoney(
                          person.amount,
                          person.currency === "NGN" ? "₦" : ""
                        )}
                      </td>
                      <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">
                        {person.destinationAccountName}
                      </td>
                      <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">
                        {formatDate(person.dateCreated)}
                      </td>
                      <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">
                        {DisplayCurrentTime(person.dateCreated)}
                      </td>
                      <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">
                        {person.destinationAccountNumber}
                      </td>
                      <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">
                        {person.destinationBankName}
                      </td>
                      <td>
                        <span
                          className={classNames(
                            statusStyles[person.transferStatus],
                            "inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium text-gray-900"
                          )}
                        >
                          {person.transferStatus}
                        </span>
                      </td>
                      <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">
                        {person.transferType}
                      </td>
                      <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">
                        {person.errormessage}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <Paginate
        nextPage={nextPage}
        pageIndex={pageIndex}
        totalCount={pageNumber}
        totalPages={totalPage}
        prevPage={prevPage}
        setPageIndex={setPageIndex}
      />
    </>
  );
};
